import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appUrlValidate][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: UrlValidateDirective, multi: true }
  ]
})
export class UrlValidateDirective implements Validator {

  private readonly urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})(:[0-9]{1,5})?(\/[\w.-]*)*\/?(\?.*)?$/;


  validate(control: AbstractControl): ValidationErrors | null {
    const validationKey = 'invalidUrl';
    const value = control.value;
    const isValid = (value == null || value == '' || this.urlRegex.test(value));

    if (!isValid) {
      return { [validationKey]: true };
    }

    return null;
  }

}